import moment from "moment";

export const addAudit = (stateChangeHandler, userId, isCreate) => {
  //console.log("<><><><><><><><><><><><><><><>");
  //console.log("userID received: " + userId);
  let date = moment().format("ddd DD-MM-YY h:mm a");
  let updateDateTime = date.toLocaleString();
  //let sortDateTime = 9999999999999 - date.getTime();

  //stateChangeHandler(sortDateTime, "sortDateTime", true);
  if (isCreate) {
    stateChangeHandler(updateDateTime, "createDateTime", true);
  } else {
    stateChangeHandler(updateDateTime, "updateDateTime", true);
  }
  if (userId !== "") {
    stateChangeHandler(userId, "author", true);
  }

  //console.log("<><><><><><><><><><><><><><><>");
};



// WEBPACK FOOTER //
// ./src/app/components/Screens/audits/addAudits.js